import * as React from 'react';

type EventCardProps = {
    className?: string;
    googleAdId: string;
    children?: React.ReactNode;
};

const AdContainer = (props: EventCardProps) => {
    const { className, googleAdId, children } = props;

    return (
        <div id={googleAdId} className={className}>
            <>{children}</>
        </div>
    );
};

export default AdContainer;
